import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { taskTemplateKeys } from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useRemoveTaskTemplatesFromProject = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['removeTaskTemplatesFromProject']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.removeTaskTemplatesFromProject,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(taskTemplateKeys.byOrganisation._def)
    },
  })
}
